<template>
  <div class="wrap">
    <div class="leftBox">
      <img-box class="box" :imgSrc="dynamicImg.invoiceSet" :activeImg="dynamicImg.invoiceSetAct" title="发票设置">
      </img-box>
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
      <img-box
        class="box"
        :imgSrc="dynamicImg.invoiceWrite"
        :activeImg="dynamicImg.invoiceWriteAct"
        title="发票填开"
        v-leftMenu="menudata"
      ></img-box>
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
    </div>

    <div class="rightBox">
      <img-box
        class="box"
        :imgSrc="dynamicImg.invoiceQuery"
        :activeImg="dynamicImg.invoiceQueryAct"
        title="发票查询"
        @click.native="query()"
      ></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.invoiceRepaire"
        :activeImg="dynamicImg.invoiceRepaireAct"
        title="发票修复"
      ></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.invoiceVoid"
        :activeImg="dynamicImg.invoiceVoidAct"
        title="发票作废"
        @click.native="toVoid()"
      ></img-box>
      <img-box
        class="box"
        :imgSrc="dynamicImg.infoSheet"
        :activeImg="dynamicImg.infoSheetAct"
        title="信息表"
        v-leftMenu="menuinfo"
      ></img-box>
    </div>
    <invoice-write ref="invoiceWriteFrom"></invoice-write>
    <invoice-query ref="invoiceQueryForm"></invoice-query>
    <invoice-void ref="invoiceVoidForm"></invoice-void>
    <info-sheet-write ref="infoSheetWrite"></info-sheet-write>
    <info-sheet-repair ref="infoSheetRepair"></info-sheet-repair>
  </div>
</template>

<script>
import ImgBox from '@/components/ImgBox/Index'
import InvoiceWrite from './InvoiceWrite/InvoiceWrite.vue'
import invoiceQuery from './invoiceQuery.vue'
import invoiceVoid from './invoiceVoid.vue'
import infoSheetWrite from './infoSheet/infoSheetWrite.vue'
import infoSheetRepair from './infoSheet/infoSheetRepair.vue'
import { dynamicImg } from '@/utils/dynamicImg'
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'

export default {
  components: {
    ImgBox,
    InvoiceWrite,
    invoiceQuery,
    invoiceVoid,
    infoSheetWrite,
    infoSheetRepair,
  },
  data() {
    return {
      dynamicImg,
      listData: [{}],
      text: 'asdas',
      getindex: '1',
      menudata: [
        {
          type: 'li', // type为ul是二级菜单
          title: '批量填开',
        },
      ],
      menuinfo: [
        {
          type: 'li',
          title: '红字增值税专用发票信息表填开',
          func: () => this.$refs.infoSheetWrite.show(),
        },
        {
          type: 'li',
          title: '红字增值税专用发票信息表维护',
          func: () => this.$refs.infoSheetRepair.show(),
        },
      ],
      taxClass: [],
    }
  },
  created() {
    this.getTaxClass()
  },
  methods: {
    showChild(type) {
      switch (type) {
        case 'invoiceWrite0':
          this.invoiceWrite(0)
          break
        case 'invoiceWrite1':
          this.invoiceWrite(1)
          break
        case 'invoiceWrite3':
          this.invoiceWrite(3)
          break
        case 'invoiceToVoid':
          this.toVoid()
          break
        case 'invoiceQuery':
          this.query()
          break
        case 'infoSheetWrite':
          this.infoSheetWrite()
          break
        case 'infoSheetRepair':
          this.infoSheetRepair()
          break
      }
    },
    async getTaxClass() {
      const params = parseParam()
      const res = await this.$http.post(`${Urls.getTaxClass}&${params}`)
      if (res) {
        this.taxClass = res.data
        this.setLeftMenu(res.data)
        this.$emit('setInvoiceType', res.data)
      }
    },
    setLeftMenu(taxClass) {
      taxClass.forEach((v) => {
        let menu
        switch (v) {
          case '0':
            menu = {
              type: 'li', // type为li是普通按钮
              title: '增值税专用发票填开', // 按钮的名称
              func: () => this.invoiceWrite(0), // 回调函数
            }
            break
          case '1':
            menu = { type: 'li', title: '增值税普通发票填开', func: () => this.invoiceWrite(1) }
            break
          case '3':
            menu = { type: 'li', title: '增值税电子普通发票填开', func: () => this.invoiceWrite(3) }
            break
        }
        this.menudata.unshift(menu)
      })
    },
    // 发票填开
    invoiceWrite(type) {
      this.$refs.invoiceWriteFrom.show(type)
    },
    // 发票查询
    query() {
      this.$refs.invoiceQueryForm.show()
    },
    // 发票作废
    toVoid() {
      this.$refs.invoiceVoidForm.show()
    },
    // 红字增值税专用发票信息表填开
    infoSheetWrite() {
      this.$refs.infoSheetWrite.show()
    },
    // 红字增值税专用发票信息表维护
    infoSheetRepair() {
      this.$refs.infoSheetRepair.show()
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 900px;
  height: 600px;
  display: block;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftBox {
  flex-basis: 45%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.rightBox {
  flex-basis: 45%;
  display: flex;
  flex-wrap: wrap;
  border-radius: 20px;
  height: 70%;
  align-items: center;
  background-color: #fff;
  .box {
    width: 50%;
  }
}
</style>
